import React, { useState } from 'react';

import { ListItemText, MenuItem } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { generatePath, NavLink } from 'react-router-dom';

import ActionMenu from '@/components/ActionMenu';
import { ProductType, setOffDuty, setOnDuty, User } from '@/core/api/collections/users';
import { ProductRevokeConfirmationModal } from '@/core/users/UserPermissions/ProductRevokeConfirmationModal';
import routes from '@/routes';

type Props = {
  user: User;
  isOffDuty?: boolean;
  onOffDutyToggled?: () => void;
  onRevokeAccess: (product: ProductType) => void;
  hasCoreAccess: boolean;
  hasUvkAccess: boolean;
}
export function UserRowActionMenu ({ user, isOffDuty, onOffDutyToggled, onRevokeAccess, hasCoreAccess, hasUvkAccess }: Props) {
  const [productToRevoke, setProductToRevoke] = useState<ProductType>();

  const toggleDutyState = async () => {
    await isOffDuty ? setOnDuty(user.id) : setOffDuty(user.id);
    onOffDutyToggled?.();
  };

  return (
    <>
      <ActionMenu
        id={`action-menu-${user.id}`}
        className="h-full"
        renderButton={() => (
          <div className="flex items-center justify-end h-full px-6">
            <MoreVert />
          </div>
        )}
      >
        {(closeMenu => ([
          <MenuItem
            key="revoke-uservoice"
            className={hasCoreAccess ? '' : 'hidden'}
            onClick={() => {
              setProductToRevoke('discovery');
              closeMenu();
            }}
          >
            <ListItemText primary="Revoke UserVoice" className="evt-revoke-uservoice" />
          </MenuItem>,
          <MenuItem
            key="revoke-validation"
            className={hasUvkAccess ? '' : 'hidden'}
            onClick={() => {
              setProductToRevoke('validation');
              closeMenu();
            }}
          >
            <ListItemText primary="Revoke Validation" className="evt-revoke-validation" />
          </MenuItem>,
          <MenuItem
            key="edit-permissions"
            component={NavLink}
            to={generatePath(routes.users.permissions, { userId: user.id })}
            onClick={() => closeMenu()}
          >
            <ListItemText primary="Edit Permissions" className="evt-edit-permissions" />
          </MenuItem>,
          <MenuItem
            className={onOffDutyToggled ? '' : 'hidden'}
            key={`set-${isOffDuty ? 'on' : 'off'}-duty`}
            onClick={() => {
              closeMenu();
              toggleDutyState();
            }}
          >
            <ListItemText primary={`Set ${isOffDuty ? 'On' : 'Off'} Duty`} className={`evt-set-${isOffDuty ? 'on' : 'off'}-duty`} />
          </MenuItem>,
        ]))}
      </ActionMenu>
      <ProductRevokeConfirmationModal
        onClose={() => setProductToRevoke(undefined)}
        onSubmit={() => {
          onRevokeAccess(productToRevoke!);
          setProductToRevoke(undefined);
        }}
        open={!!productToRevoke}
        product={productToRevoke}
        licenseType={user.permissions.core?.licenseType}
      />
    </>
  );
}
